import { render, staticRenderFns } from "./SoftwareNet.vue?vue&type=template&id=86d0121e&scoped=true&"
import script from "./SoftwareNet.vue?vue&type=script&lang=js&"
export * from "./SoftwareNet.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareNet.vue?vue&type=style&index=0&id=86d0121e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d0121e",
  null
  
)

export default component.exports